<template>
  <div>
    <MainCard v-if="!isLoadingTable">
      <template v-slot:body>
        <DataTablePagination
          :page="page"
          :total-items="totalItems"
          :headers="headers"
          :search="search"
          :is-loading="isLoadingData"
          title="Pelanggaran Pegawai"
          subtitle="Pegawai yang melakukan pelanggaran"
          :items="employeeViolations"
          add-btn="Tambah Data"
          :total-pages.sync="totalPages"
          @add-item="showFormAdd"
          @edit-item="showFormEdit"
          @delete-item="confirmDestroy"
          @page="page"
          @change-page="paginationHandler"
          @live-search="searchHandler"
        >
        </DataTablePagination>
      </template>
    </MainCard>
    <SkeletonLoaderTable v-else></SkeletonLoaderTable>
    <ModalDialog
      :visible="modalDialog"
      :width="width"
      :is-loading-button="isLoadingButton"
      :is-disabled-button="!formValid"
      :header="dialog ==='add'? 'Tambah Pelanggaran Pegawai': 'Edit Pelanggaran Pegawai'"
      :text-button="dialog ==='add'? 'Tambah': 'Update'"
      @close-button="modalDialog = false"
      @handler-button="handlerButton"
      @close-modal="modalDialog = false"
    >
      <template v-slot:body>
        <v-row>
          <v-col
            cols="12"
            class="py-0"
          >
            <div>
              <v-menu
                v-model="date_menu"
                :close-on-content-click="true"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="employeeViolation.violation_date"
                    label="Tanggal"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    clearable
                    v-on="on"
                    @click="autofillDate"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="employeeViolation.violation_date"
                  :first-day-of-week="0"
                  locale="id-id"
                  color="primary"
                  @input="date_menu = false"
                ></v-date-picker>
              </v-menu>
            </div>
          </v-col>
          <v-col
            cols="12"
            class="py-0"
          >
            <div>
              <v-autocomplete
                v-model="employeeViolation.employee_uuid"
                label="Nama Pegawai"
                dense
                outlined
                :items="employees"
                item-text="name"
                item-value="uuid"
                clearable
              ></v-autocomplete>
            </div>
          </v-col>
          <v-col
            cols="12"
            class="py-0"
          >
            <div>
              <v-autocomplete
                v-model="employeeViolation.violation_uuid"
                label="Pelanggaran"
                dense
                outlined
                :items="violations"
                item-text="name"
                item-value="uuid"
                clearable
              ></v-autocomplete>
            </div>
          </v-col>
          <v-col
            cols="12"
            class="py-0"
          >
            <div>
              <v-textarea
                v-model="employeeViolation.description"
                label="Deskripsi"
                dense
                outlined
              ></v-textarea>
            </div>
          </v-col>
          <v-col
            cols="12"
            class="py-0"
          >
            <div>
              <v-text-field
                v-model="employeeViolation.follow_up"
                label="Tindak Lanjut"
                dense
                outlined
              ></v-text-field>
            </div>
          </v-col>
        </v-row>
      </template>
    </ModalDialog>

    <ConfirmDialog
      :visible="confirmDialog"
      :is-loading-button="isLoadingButton"
      header="Hapus Pelanggaran Pegawai"
      @close-button="confirmDialog = false"
      @destroy-button="destroy"
    >
    </ConfirmDialog>
  </div>
</template>

<script>
import ConfirmDialog from '@/views/components/ConfirmDialog.vue'
import DataTablePagination from '@/views/components/DataTablePagination.vue'
import MainCard from '@/views/components/MainCard.vue'
import ModalDialog from '@/views/components/ModalDialog.vue'
import SkeletonLoaderTable from '@/views/components/SkeletonLoaderTable.vue'

export default {
  name: 'Violationemployee',
  components: {
    DataTablePagination,
    ModalDialog,
    MainCard,
    SkeletonLoaderTable,
    ConfirmDialog,
  },
  data() {
    return {
      skeleton: {
        class: 'mb-6',
        boilerplate: false,
        elevation: 5,
        types: {},
      },
      page: 1,
      search: '',
      totalItems: 0,
      totalPages: 0,
      width: 600,
      modalDialog: false,
      confirmDialog: false,
      dialog: null,
      headers: [
        { text: 'No', value: 'index' },
        { text: 'Tanggal', value: 'violation_date' },
        { text: 'Nama Pegawai', value: 'employee.name' },
        { text: 'Pelanggaran', value: 'violation.name' },
        { text: 'Deskripsi', value: 'description' },
        { text: 'Poin', value: 'violation.point' },
        { text: 'Tindak Lanjut', value: 'follow_up' },
        { text: 'Aksi', value: 'actions' },
      ],
      employees: [],
      violations: [],
      employeeViolations: [],
      employeeViolation: {
        uuid: '',
        violation_uuid: '',
        school_uuid: '',
        employee_uuid: '',
        violation_date: '',
        description: '',
        follow_up: '',
      },
      date_menu: false,
      isLoadingTable: true,
      isLoadingData: false,
      isLoadingButton: false,
      school: '',
      school_uuid: '',
      user_uuid: '',
      filterQuery: {
        search: '',
      },
      formValid: false,
    }
  },
  watch: {
    employeeViolation: {
      handler() {
        const valid = []
        const requiredField = ['employee_uuid', 'follow_up', 'description', 'violation_date', 'violation_uuid']
        Object.entries(this.employeeViolation).forEach(([key, item]) => {
          if (requiredField.includes(key)) valid.push(!!(item && item.length))
        })
        this.formValid = !valid.includes(false)
      },
      deep: true,
    },
    page: {
      handler() {
        this.listViolationEmployee(this.filterQuery)
      },
    },
  },
  async mounted() {
    this.isLoadingTable = true
    this.getSchoolUuid()
    await this.listViolationEmployee()
    await this.listEmployee()
    await this.listViolation()
    this.isLoadingTable = false
  },
  methods: {
    getSchoolUuid() {
      this.school = JSON.parse(localStorage.getItem('user')).user.details
      this.school.forEach(el => {
        if (el.school === undefined) {
          this.school_uuid = el.uuid

          return
        }
        if (el.school === null) {
          this.showSnackbar({
            text: "You don't have access to school",
            color: 'error',
          })

          return
        }
        this.school_uuid = el.school.uuid
      })

      return true
    },

    async listEmployee(params = {}) {
      await this.$services.ApiServices.list('employee', {
        ...params,
        school: this.school_uuid,
        page: this.page,
      }).then(
        ({ data }) => {
          this.isLoadingData = true
          this.employees = data.data
          this.isLoadingData = false
        },
        err => {
          console.error(err)
        },
      )
    },

    async listViolation(params = {}) {
      await this.$services.ApiServices.list('violation', {
        ...params,
        school_uuid: this.school_uuid,
        per_page: 'all',
      }).then(
        ({ data }) => {
          this.isLoadingData = true
          this.violations = data.data
          this.isLoadingData = false
        },
        err => {
          console.error(err)
        },
      )
    },

    async listViolationEmployee(params = {}) {
      this.isLoadingData = true
      await this.$services.ApiServices.list('violationemployee', {
        ...params,
        school: this.school_uuid,
        page: this.page,
      }).then(
        ({ data }) => {
          this.employeeViolations = data.data.map((employeeViolations, index) => ({
            ...employeeViolations,
            index: index + 1,
          }))
          this.totalPages = data.meta.last_page
          this.totalItems = data.meta.total
        },
        err => {
          console.error(err)
        },
      )
      this.isLoadingTable = false
      this.isLoadingData = false
    },

    resetForm() {
      this.employeeViolation.uuid = ''
      this.employeeViolation.employee_uuid = ''
      this.employeeViolation.violation_uuid = ''
      this.employeeViolation.violation_date = ''
      this.employeeViolation.description = ''
      this.employeeViolation.follow_up = ''
    },

    showSnackbar(snackbarData) {
      this.$store.dispatch('snackbar/showSnackbar', snackbarData)
    },

    showFormAdd() {
      this.dialog = 'add'
      this.resetForm()
      this.modalDialog = true
    },

    async add() {
      this.isLoadingButton = true
      this.employeeViolation.school_uuid = this.school_uuid
      await this.$services.ApiServices.add('violationemployee', this.employeeViolation).then(
        ({ data }) => {
          this.showSnackbar({
            text: data.result.message,
            color: 'success',
          })
          this.listViolationEmployee(this.filterQuery)
          this.resetForm()
          this.modalDialog = false
        },
        err => {
          this.isLoadingButton = false
          console.error(err)
        },
      )
      this.isLoadingButton = false
    },

    async showFormEdit(uuid) {
      this.dialog = 'edit'
      await this.$services.ApiServices.get('violationemployee', uuid).then(
        ({ data }) => {
          this.employeeViolation.uuid = data.data.uuid
          this.employeeViolation.employee_uuid = data.data.employee.uuid
          this.employeeViolation.violation_uuid = data.data.violation.uuid
          this.employeeViolation.violation_date = data.data.violation_date
          this.employeeViolation.description = data.data.description
          this.employeeViolation.follow_up = data.data.follow_up
        },
        err => console.error(err),
      )
      this.modalDialog = true
    },

    async update() {
      this.isLoadingButton = true
      this.employeeViolation.school_uuid = this.school_uuid
      await this.$services.ApiServices.update(
        'violationemployee',
        this.employeeViolation,
        this.employeeViolation.uuid,
      ).then(
        ({ data }) => {
          this.listViolationEmployee(this.filterQuery)
          this.resetForm()
          this.showSnackbar({
            text: data.result.message,
            color: 'success',
          })
          this.modalDialog = false
        },
        err => {
          this.isLoadingButton = false
          console.error(err)
        },
      )
      this.isLoadingButton = false
    },
    handlerButton() {
      if (this.dialog === 'add') this.add()
      else this.update()
    },
    confirmDestroy(uuid) {
      this.confirmDialog = true
      this.employeeViolation.uuid = uuid
    },

    async destroy() {
      this.isLoadingButton = true
      await this.$services.ApiServices.destroy('violationemployee', this.employeeViolation.uuid).then(
        ({ data }) => {
          this.listViolationEmployee(this.filterQuery)
          this.showSnackbar({
            text: data.result.message,
            color: 'success',
          })
          this.isLoadingButton = false
          this.confirmDialog = false
        },
        err => {
          this.isLoadingButton = false
          console.error(err)
        },
      )
    },

    paginationHandler(pageNumber) {
      this.page = pageNumber
    },

    searchHandler(search) {
      this.filterQuery.search = search
      this.page = 1
      this.listViolationEmployee(this.filterQuery)
    },

    autofillDate() {
      this.employeeViolation.violation_date = new Date().toISOString().substr(0, 10)
    },
  },
}
</script>

<style scoped>
.v-menu__content::v-deep {
  min-width: 0 !important;
}
</style>
